<template>
  <div class="popup-wrapper">
    <div class="popup-overlay" @click="$emit('closePopup')"></div>
    <div class="popup popup--request-contact" v-if="step === 1">
      <button class="popup-close" @click="$emit('closePopup')"></button>

      <div class="form-block" :class="{'form-block--warning': validationObject.subject}">
        <div class="form-block-inner">
          <label>Topic</label>
          <textarea id="request-topic" v-model="data.message.subject" placeholder="Start typing..."></textarea>
        </div>
        <div class="form-error" v-if="validationObject.subject">
          <i class="icon-error"></i> Topic is required
        </div>
      </div>

      <div class="form-block" :class="{'form-block--warning': validationObject.content}">
        <div class="form-block-inner">
          <label>Message</label>
          <textarea v-model="data.message.content" placeholder="Start typing..."></textarea>
        </div>
        <div class="form-error" v-if="validationObject.content">
          <i class="icon-error"></i> Message is required
        </div>
      </div>

      <div class="popup-bottom">
        <button class="button-icon button--submit" @click="validateAndSend">Submit <i class="icon-send"></i></button>
        <button class="button" @click="$emit('closePopup')">Cancel</button>
      </div>
    </div>
    <div class="popup popup--success-message" v-if="step === 2">
      <button class="popup-close" @click="$emit('closePopup')"></button>
      <i class="icon-mail-1"></i>
      <div class="popup-title">Your message was sent successfully</div>
      <button class="button--submit" @click="$emit('closePopup')">Close</button>
    </div>
  </div>
</template>

<script>
import settings from "@/settings";
import api from "@/api/sendEmail";

export default {
  name: "PopupRequestContact",
  props: ['data'],
  data () {
    return {
      step: 1,
      validationObject: {
        subject: false,
        content: false,
      },
      error: false
    }
  },
  methods: {
    trackSendContactRequestSolution () {
      this.$gtag.event('SendContactRequestSolution', {
        'event_category': this.$store.getters.company.name,
        'company_name': this.$store.getters.company.name,
        'event_label': this.$route.path,
        'value': this.data.message.subject
      })
    },
    validateAndSend() {
      this.validate();
      if(this.error) {
        return null
      }
      this.send()
    },
    validate() {
      this.error = false;
      if(!this.data.message.subject) {
        this.error = true;
        this.validationObject.subject = true
      }
      if(!this.data.message.content) {
        this.error = true;
        this.validationObject.content = true
      }
    },
    send() {
      let data = {
        ...this.data.message,
        addresses: [this.data.email],
        idUser: this.$store.getters.user.idUser
      }

      if(settings.ENV === 'STAGE') {
        data.addresses = ['joanna.lebica@capgemini.com']
        data.subject = `STAGE: ${data.subject}`
      }
      api.sendEmail(data, () => {
        this.step = 2
        this.trackSendContactRequestSolution();
        document.querySelector('body').classList.add('nooverflow')
      })
    }
  }
}
</script>
